export const yandexApiKey = "1ead53b8-e117-41e7-91f9-a3bce597e13c";